import RedeemFinish from './RedeemFinish';

export default RedeemFinish;
